export const SCROLL_LOCK_ALLOWED_SELECTORS: string[] = ['#app-modal', '#catalog-filters'];
export const SCROLL_LOCK_OWNER_FILTERS: string = 'filters';
